import React from 'react'
import './index.less'
import { useEffect, useState } from 'react'
import { PaintingCard } from '@/components/PaintingCard'
import { getWorkRequest } from '@/server'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import {
  setShowType,
  setInfoKey,
  setInfoValue
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getPaintingCardTrackStyle, usePaintingCardsPerPage } from '../paintingCardCarousel'

const themeList = {
  山水: { content: [], count: 0 },
  人物: { content: [], count: 0 },
  花鸟: { content: [], count: 0 }
}

export function Theme() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const _navigate = useNavigate()
  const cardsPerPage = usePaintingCardsPerPage()
  // 每个列表共展现作品的数目
  const perListLength = 9
  // 每个展示列表中第一个作品的index
  const [showIndex, setShowIndex] = useState<number[]>(
    new Array(Object.keys(themeList).length).fill(0)
  )
  // 展示内容列表
  const [showList, setShowList] = useState<object>(themeList)
  // 初始化展示内容
  useEffect(() => {
    Object.keys(themeList).forEach((theme) =>
      getWorkRequest(
        {
          criteria: [
            {
              key: 'class1',
              value: theme
            }
          ],
          pages: {
            page: 1,
            size: perListLength
          }
        },
        token
      ).then((res) => {
        themeList[theme].content = res.data.content.list
        themeList[theme].count = res.data.content.total
        const deepClone = JSON.parse(JSON.stringify(themeList))
        setShowList(deepClone)
      })
    )
  }, [])
  /**
   * 向小序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handlePre = function (index: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return x - cardsPerPage < 0 ? 0 : x - cardsPerPage
      } else return x
    })
    setShowIndex(newIndex)
  }
  /**
   * 向大序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handleNext = function (index: number, len: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return Math.min(x + cardsPerPage, Math.max(0, len - cardsPerPage))
      } else return x
    })
    setShowIndex(newIndex)
  }
  // 查看详情的回调，给二级页面传相应配置
  function handleIndexSecondPage(theme) {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey('class1'))
    dispatch(setInfoValue(theme))
    // navigate("./indexSecond")
    window.open('/indexSecond')
  }
  return (
    <div className='theme-container'>
      {Object.keys(showList).map((theme, index) => (
        <div className='theme'>
          <div className='theme-title'>
            <div className='theme-name'>{theme}</div>
            <div className='btn-box'>
              <div
                className={'btn ' + (showIndex[index] === 0 ? 'disabled' : 'abled')}
                onClick={(_e) => handlePre(index)}
              >
                <ArrowLeftOutlined
                  style={{
                    margin: 'auto',
                    color: showIndex[index] === 0 ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                  }}
                />
              </div>
              <div
                className={
                  'btn ' +
                  (showIndex[index] >= Math.max(0, showList[theme].content.length - cardsPerPage)
                    ? 'disabled'
                    : 'abled')
                }
                onClick={(_e) => handleNext(index, showList[theme].content.length)}
              >
                <ArrowRightOutlined
                  style={{
                    margin: 'auto',
                    color:
                      showIndex[index] >= Math.max(0, showList[theme].content.length - cardsPerPage)
                        ? 'rgb(180, 179, 173)'
                        : 'rgb(72, 66, 51)'
                  }}
                />
              </div>
            </div>
          </div>
          <div className='theme-subtitle'>
            <div className='theme-count'>共计 {showList[theme].count} 件作品</div>
            <div className='check-all-btn' onClick={() => handleIndexSecondPage(theme)}>
              查看所有画作
              <ArrowRightOutlined
                style={{
                  color: 'rgb(72, 66, 51)',
                  fontSize: '14px'
                }}
              />
            </div>
          </div>
          <div className='painting-card-viewport'>
            <div className='theme-content' style={getPaintingCardTrackStyle(showIndex[index])}>
              {showList[theme].content.map((work) => (
                <PaintingCard
                  title={work.workname}
                  dynasty={work.dynasty}
                  author={work.authorname}
                  museum={work.instname}
                  image={work.encoding}
                  id={work.workid}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
